module.exports = __webpack_public_path__ + "img/img6.238399c3.png";